import { render, staticRenderFns } from "./AlarmTypeAddModal.vue?vue&type=template&id=32791678&scoped=true&"
import script from "./AlarmTypeAddModal.vue?vue&type=script&lang=js&"
export * from "./AlarmTypeAddModal.vue?vue&type=script&lang=js&"
import style0 from "./AlarmTypeAddModal.vue?vue&type=style&index=0&id=32791678&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32791678",
  null
  
)

export default component.exports